import { render, staticRenderFns } from "./FormTemplateVersionDetailsCard.vue?vue&type=template&id=7fa1df88&scoped=true&"
import script from "./FormTemplateVersionDetailsCard.vue?vue&type=script&lang=js&"
export * from "./FormTemplateVersionDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateVersionDetailsCard.vue?vue&type=style&index=0&id=7fa1df88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa1df88",
  null
  
)

export default component.exports